/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooter_item = {
    readonly isArt: boolean | null;
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespComplementaryItemsGrid_item">;
    readonly " $refType": "PdpRespSimilarItemsFooter_item";
};
export type PdpRespSimilarItemsFooter_item$data = PdpRespSimilarItemsFooter_item;
export type PdpRespSimilarItemsFooter_item$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_item",
      "args": null
    }
  ]
};
(node as any).hash = 'd5a05d2479dd73a9dded3b023516f419';
export default node;
